<template>
    <el-card shadow="never" class="aui-card--fill">
      <div class="mod-demo__operations}">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
          <el-form-item>
            <el-date-picker
                    v-model="dataForm.startTime"
                    type="date"
                    placeholder="录入时间"
                    value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
          <el-select v-model="dataForm.companyId" filterable  clearable placeholder="公司">
            <el-option
                    v-for="item in companys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
          <el-form-item>
            <el-button @click="getDataList()">{{ $t('query') }}</el-button>
          </el-form-item>
        
        </el-form>
        <!-- <el-table v-loading="dataListLoading" :data="dataList" border  style="width: 100%;">
          <el-table-column prop="companyName" label="公司名" header-align="center" align="center"></el-table-column>
          <el-table-column prop="nums" label="推送条数" header-align="center" align="center"></el-table-column>
        </el-table> -->
        <el-table
        v-loading="dataListLoading"
        :data="tableData"
        :span-method="objectSpanMethod"
        border
        style="width: 100%;
        margin-top: 20px"
        >
        <el-table-column
          prop="companyName"
          label="门店"
          header-align="center" align="center"
          width="180">
        </el-table-column>
        <el-table-column
          prop="channelName"
          label="渠道"
          header-align="center" align="center"
          >
        </el-table-column>
        <el-table-column
          prop="productType"
          label="贷款类型"
          header-align="center" align="center"
          >
        </el-table-column>
          <el-table-column
          prop="productSum"
          label="贷款类数量"
          header-align="center" align="center"
          >
        </el-table-column>
        <el-table-column
          prop="nums"
          label="数量"
          header-align="center" align="center"
          >
        </el-table-column>
        <el-table-column
          prop="sum"
          label="总数"
          header-align="center" align="center"
          >
        </el-table-column>
      </el-table>

        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <!-- <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update> -->
      </div>
    </el-card>
  </template>
  
  <script>
  import mixinViewModule from '@/mixins/view-module'
//   import AddOrUpdate from './operations-add-or-update'
  export default {
    mixins: [mixinViewModule],
    data () {
      return {
        mixinViewModuleOptions: {
          getDataListURL: '/zy/dailyReport/page',
          getDataListIsPage: true,
          exportURL: '/sys/operations/export',
          deleteURL: '/sys/operations',
          deleteIsBatch: true
        },
        dataForm: {
          id: '',
          startTime: '',
          companyId: '',
        },
        tableData: [],
        companys: [],
      }
    },
    watch: {
      dataList: {
        handler(n,o){
          this.tableData = []
          n.map(item => {
          item.dailyReportChannel.map(item1 => {
          item1.productType.map(item2 => {
            this.tableData.push({...item1 , ...item , ... item2, tab: `${item.companyName}${item1.channelName}`})
          })
          })
        })
        console.log(this.tableData)
        }
      }
    },
    mounted () {
      this.getCompanysOptions()
    },
    methods: {
      mergeCol(id, rowIndex) { // 合并单元格
    // id：属性名
    // rowIndex：行索引值
      var idName = this.tableData[rowIndex][id] // 获取当前单元格的值
      console.log(rowIndex,'rowIndex')
      // console.log(idName)
      if (rowIndex > 0) { // 判断是不是第一行
        console.log('1','rowIndex',rowIndex)
        // eslint-disable-next-line eqeqeq
        if (this.tableData[rowIndex][id] != this.tableData[rowIndex - 1][id]) { // 先判断当前单元格的值是不是和上一行的值相等
          var i = rowIndex; var num = 0 // 定义一个变量i，用于记录行索引值并进行循环，num用于计数
          while (i < this.tableData.length) { // 当索引值小于table的数组长度时，循环执行
            if (this.tableData[i][id] === idName) { // 判断循环的单元格的值是不是和当前行的值相等
              i++ // 如果相等，则索引值加1
              num++ // 合并的num计数加1
            } else {
              i = this.tableData.length // 如果不相等，将索引值设置为table的数组长度，跳出循环
            }
          }
          return {
            rowspan: num, // 最终将合并的行数返回
            colspan: 1
          }
        } else {
          return {
            rowspan: 0, // 如果相等，则将rowspan设置为0
            colspan: 1
          }
        }
      } else { // 如果是第一行，则直接返回
        console.log('2','rowIndex',rowIndex)
        let i = rowIndex; let num = 0
        while (i < this.tableData.length) { // 当索引值小于table的数组长度时，循环执行
          if (this.tableData[i][id] === idName) {
            i++
            num++
          } else {
            i = this.tableData.length
          }
        }
        // console.log(num)
        return {
          rowspan: num,
          colspan: 1
        }
      }
    },
    // 这个方法是 element-ui提供的单元格合并方法
    // objectSpanMethod 传入了 { row, column, rowIndex, columnIndex }
    // row: 当前行
    // column: 当前列
    // rowIndex：当前行号
    // columnIndex ：当前列号
    // 1代表：独占一行
    // 更大的自然数：代表合并了若干行
    // 0：代表“消失”的哪那一个单元格，后面的单元格向前推一格
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if(columnIndex === 0){
              console.log( this.mergeCol('companyName', rowIndex))
              return this.mergeCol('companyName', rowIndex)
             }
             if(columnIndex === 1){
              return this.mergeCol('tab', rowIndex)
             }
             if(columnIndex === 4){
              return this.mergeCol('tab', rowIndex)
             }
             if(columnIndex === 5){
              return this.mergeCol('companyName', rowIndex)
             }
        },
         //初始化公司下拉框中的选项
    async getCompanysOptions() {
      this.$http.get(`/sys/companies/list`).then(({data: res}) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.companys = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.companys.push({label: element.name, value: element.id})
          })
        }
      }).catch(() => {
      })
    },
    }
 
  }
  </script>


<style scoped>

</style>
  